module.exports = __webpack_public_path__ + "static/media/15.745ca4a7.jpg";